import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { SohoTooltipDirective } from 'ids-enterprise-ng';
@Directive({
    selector: '[lm-custom-tooltip]'
})
export class LMCustomTooltipDirective {
    @Input() tooltipPlacement: string = 'top';
    @Input() tooltipContent?: string;
    private tooltip = null;

    constructor(private element: ElementRef) {

    }

    ngOnInit() {
        this.applyStyleOverflowEllipsis();
    }

    ngOnDestroy() {
        if (this.tooltip) {
            this.tooltip.ngOnDestroy();
        }
    }

    private isTooltipNeeded(): boolean {
        return this.element.nativeElement.offsetWidth < this.element.nativeElement.scrollWidth;
    }

    @HostListener('mouseenter') onMouseEnter() {
        if (this.isTooltipNeeded()) {
            this.tooltip = new SohoTooltipDirective(this.element);
            this.tooltip.content = this.tooltipContent ? this.tooltipContent : this.element.nativeElement.innerText;
            this.tooltip.placement = this.tooltipPlacement;
            this.tooltip.maxWidth = this.element.nativeElement.scrollWidth + 20; //additional 20px to offset the tooltip padding and display the whole description
            this.tooltip.ngAfterViewInit();
            this.tooltip.show();
        }
    }

    private applyStyleOverflowEllipsis(): void {
        this.element.nativeElement.style.whitespace = 'nowrap';
        this.element.nativeElement.style.overflow = 'hidden';
        this.element.nativeElement.style.textOverflow = 'ellipsis';
    }
}
